import { render } from "./WelcomeImg2.vue?vue&type=template&id=f25cec5e"
import script from "./WelcomeImg2.vue?vue&type=script&lang=js"
export * from "./WelcomeImg2.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__